// src/components/SessionWarning/SessionWarning.js
import React, { useState, useEffect } from 'react';
import { useStore } from '../../stores';
import './SessionWarning.css';

const SessionWarning = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const { authStore, uiStore } = useStore();

  useEffect(() => {
    const handleShowWarning = () => {
      setIsVisible(true);
      setCountdown(60);
      
      // Start countdown
      const interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsVisible(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    };

    window.addEventListener('showSessionWarning', handleShowWarning);
    
    return () => {
      window.removeEventListener('showSessionWarning', handleShowWarning);
    };
  }, []);

  const extendSession = async () => {
    try {
      const success = await authStore.refreshToken();
      if (success) {
        setIsVisible(false);
        uiStore.showNotification('Session extended successfully', 'success', 3000);
      } else {
        uiStore.showNotification('Failed to extend session', 'error');
      }
    } catch (error) {
      uiStore.showNotification('Error extending session', 'error');
    }
  };

  const logout = () => {
    authStore.logout();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="session-warning-header">
          <h3>Session About to Expire</h3>
        </div>
        <div className="session-warning-body">
          <p>Your session will expire in {countdown} seconds.</p>
          <p>Would you like to extend your session?</p>
        </div>
        <div className="session-warning-actions">
          <button 
            onClick={extendSession} 
            className="btn btn-primary"
            autoFocus
          >
            Extend Session
          </button>
          <button 
            onClick={logout} 
            className="btn btn-secondary"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarning;